import {IPerRoadSeasonImperial} from "@/modules/perRoad/interfaces/perRoad";
import {UnitSystem} from "@/interfaces/units";

/**
 * Seasons
 */

export const summer: IPerRoadSeasonImperial = {
  id: null,
  name: 'Summer',
  duration_weeks: 26,
  enabled: true,
  temp_degF: 70,
  unitSystem: UnitSystem.Imperial,
};

export const fall: IPerRoadSeasonImperial = {
  id: null,
  name: 'Fall',
  duration_weeks: 8,
  enabled: true,
  temp_degF: 50,
  unitSystem: UnitSystem.Imperial,
};

export const winter: IPerRoadSeasonImperial = {
  id: null,
  name: 'Winter',
  duration_weeks: 12,
  enabled: true,
  temp_degF: 20,
  unitSystem: UnitSystem.Imperial,
};

export const spring: IPerRoadSeasonImperial = {
  id: null,
  name: 'Spring',
  duration_weeks: 6,
  enabled: true,
  temp_degF: 50,
  unitSystem: UnitSystem.Imperial,
};
